"use client"

import { Paragraph } from "@/components/ui-library/typography/Body"
import { useListingStore } from "@/store/listing-store"
import errorIcon from "@public/error_image.svg"
import { Button } from "@ui-library/button/Button"
import PageContainer from "@ui-library/layout/PageContainer"
import Image from "next/image"
import { useRouter, useSearchParams } from "next/navigation"

const ListingErrorPage = () => {
  const story = useListingStore.getState().story
  const data = story?.content
  const searchParams = useSearchParams()
  const { push } = useRouter()

  const errorCode = searchParams?.get("error_code") ?? "000"
  const errorMessage = searchParams?.get("error_message") ?? "Unknown Error"

  const handleButtonClick = () => {
    push("/lista-dig")
  }

  return (
    <>
      <PageContainer className="my-12">
        <div className="mx-auto mb-8 mt-4 flex max-w-[340px] flex-col items-center justify-center md:max-w-[800px] md:flex-row-reverse">
          <Image
            src={errorIcon}
            width={500}
            height={256}
            alt="error"
            className="h-40 w-full md:ml-8 md:mr-2 md:h-64 md:w-[600px]"
          />

          <div className="mt-6 flex flex-col items-start justify-start text-left md:ml-2 md:mt-4">
            <h3 className="text-left">{data?.error_title}</h3>
            <h4 className="text-left">Error {errorCode}</h4>

            <Paragraph size="small">{errorMessage}</Paragraph>

            <div className="mt-8">
              <Button onClick={handleButtonClick}>{data?.error_button_text}</Button>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  )
}

export default ListingErrorPage
